import BlueByteLogo from '@assets/icons/blue_byte_sider_logo.svg';
import SmallBlueByteLogo from '@assets/icons/home-logo.svg';
import { BORDER_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const SiderLogoDiv = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 16px;

    img {
        aspect-ratio: 82.5/24;
    }
`;

export const SmallBlueByteLogoWrapper = styled(SmallBlueByteLogo)`
    width: 32px;
    height: 32px;
`;

export const BlueByteLogoWrapper = styled(BlueByteLogo)`
    width: 83px;
    height: 24px;
`;

export const SiderPoweredBy = styled.div`
    color: ${BORDER_COLORS.white};
    text-align: center;
    margin-top: 4px;

    ${FONT_FAMILY.poppins}
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
`;
